<div class="modal-header">
  <h4 class="modal-title">Assignment of {{ projectName }}</h4>
</div>
<div class="modal-body">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <b>Currently assigned to:</b>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <p *ngIf="!isLoading && assignees.length === 0" style="margin-top: 8px">This project is not shared with anyone yet.</p>

        <ul *ngIf="assignees.length > 0" class="list-group" style="margin-top: 8px; margin-bottom: 8px">
          <li
            *ngFor="let assignee of assignees"
            class="list-group-item d-flex justify-content-between align-items-center"
            style="display: flex; justify-content: space-between; align-items: center"
          >
            <span>{{ assignee }}</span>
            <button type="button" class="btn btn-danger btn-sm" title="Remove assignment" (click)="removeAssignee(assignee)">
              <i class="bi bi-x-lg"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-12">
        <b>With whom do you want to share this project?</b>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-6">
        <form [formGroup]="assignmentForm" class="col-md-8" style="align-items: center">
          <si-newton-form-group
            label="Email"
            [errorResolverMap]="{ required: 'Value is required', pattern: 'Valid email adress is needed' }"
          >
            <input formControlName="email" type="email" email siNewton />
          </si-newton-form-group>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3"></div>

      <div class="col-md-3">
        <button type="button" class="btn btn-primary" style="float: left" (click)="modalRef.hide()">Close</button>
      </div>

      <div class="col-md-3">
        <button type="button" class="btn btn-success" style="float: left" [disabled]="!assignmentForm.valid" (click)="addAssignee()">
          Add person
        </button>
      </div>

      <div class="col-md-3"></div>
    </div>
  </div>
</div>

<div class="modal-footer"></div>
